module.exports = "https://static.wagwalking.com/_next/static/images/wag_app_image-575fa6094a72afeb92869a3237714304.png";